export default "__VITE_ASSET__CBUyg2H6__"